import React from "react";

export default function FitToWindowButton(props){
    return(
        <a href="#" className={' d-none d-sm-block'} onClick={props.onFitToWindowButtonClick}>Fit to Window</a>
    )
}
